import logo from "../../assets/logos/evisens-logo.svg";
import "../../StyleCSS/EvisensLogo.css";

export default function EvisensLogo() {
  return (
    <div className="evisens-logo-container">
      <img className="evisens-logo" src={logo} alt={"Evisens logotyp"} />
    </div>
  );
}
